import { ProductDetails, ProductGallery } from "@/components/organisms"
import { listProducts } from "@/lib/data/products"
import { listOffers } from "@/lib/data/offers"
import { StoreOffer } from "@/lib/helpers/buybox"
import { HomeProductSection } from "../HomeProductSection/HomeProductSection"
import NotFound from "@/app/not-found"
import { PartPlaceholder } from "@/components/atoms/PartImage/PartImage"
import { getCatalogByProduct } from "@/lib/data/catalog"

export const ProductDetailsPage = async ({
  handle,
  locale,
}: {
  handle: string
  locale: string
}) => {
  const prod = await listProducts({
    countryCode: locale,
    queryParams: { handle: [handle], limit: 1 },
  }).then(({ response }) => response.products[0])

  if (!prod) return null

  if (prod.seller?.store_status === "SUSPENDED") {
    return NotFound()
  }

  const [{ offers }, cat] = await Promise.all([
    listOffers({ productId: prod.id, countryCode: locale }),
    getCatalogByProduct(prod.id),
  ])
  // بلا صور: رسمة توضيحية لنوع القطعة بدل مساحة فارغة
  const hasImages = Boolean(prod.images?.length || prod.thumbnail)
  const part: any = cat?.part

  return (
    <>
      <div className="flex flex-col md:flex-row lg:gap-12" data-testid="product-details-page">
        <div className="md:w-1/2 md:px-2" data-testid="product-gallery-container">
          {hasImages ? (
            <ProductGallery images={prod?.images || []} />
          ) : (
            <div className="aspect-square w-full overflow-hidden rounded-sm border">
              <PartPlaceholder
                group={part?.group_name ?? (prod as any).categories?.[0]?.name}
                name={part?.name_ar ?? part?.part_type ?? prod.title}
              />
            </div>
          )}
        </div>
        <div className="md:w-1/2 md:px-2" data-testid="product-details-container">
          <ProductDetails
            product={prod}
            locale={locale}
            offers={offers as StoreOffer[]}
          />
        </div>
      </div>
      <details suppressHydrationWarning className="my-8 order-last" dir="rtl">
        <summary className="cursor-pointer rounded-sm border px-4 py-3 text-sm font-medium">
          عرض المزيد من هذا البائع
        </summary>
        <p className="mt-2 text-xs text-gray-500">
          هذه منتجات أخرى للبائع نفسه وليست بدائل مضمونة — تأكّد من توافقها مع سيارتك قبل الشراء.
        </p>
        <HomeProductSection
          heading="منتجات أخرى من نفس البائع"
          products={prod.seller?.products}
          locale={locale}
        />
      </details>
    </>
  )
}
